import React from "react"
import CustomButton from "../../OnboardingComponents/CustomButton"
import CustomIconButton from "../../OnboardingComponents/CustomIconButton"
import SessionDetailMeta from "./SessionDetailMeta"
import SessionTimerControl from "./SessionTimerControl"
import { ICONS } from "../../../constants/icons"

const SessionDetailMini = ({
  session,
  timer,
  isTimerUpdating = false,
  onTimerToggle,
  onRestore,
  onExit,
}) => {
  const hasLeftSession = Boolean(session?.hasLeftSession)
  const sessionEnded =
    hasLeftSession ||
    String(session?.status || "").toLowerCase() === "ended" ||
    Boolean(session?.endedAtRaw)

  return (
  <div
    className="session-detail-mini"
    onClick={event => {
      if (event.target?.closest?.("[data-pip-no-drag]")) return
      onRestore?.(event)
    }}
  >
    <SessionDetailMeta
      session={session}
      layout="compact"
      tagsAction={
        <div className="session-detail-mini__controls" data-pip-no-drag>
          <CustomIconButton
            iconSrc={ICONS.minimize}
            label="Restore session detail"
            size="sm"
            className="session-detail-mini__expand"
            onClick={event => {
              event.stopPropagation()
              onRestore?.(event)
            }}
          />
        </div>
      }
    />

    <div className="session-detail-mini__footer">
      <SessionTimerControl
        timer={timer}
        timerStatus={session?.timerStatus}
        canToggleTimer={session?.canToggleTimer}
        showToggle={!sessionEnded}
        isTimerUpdating={isTimerUpdating}
        onTimerToggle={onTimerToggle}
      />

      <div
        data-pip-no-drag
        onClick={event => {
          event.preventDefault()
          event.stopPropagation()
          onExit?.(event)
        }}
      >
        <CustomButton
          variant="danger"
          size="md"
          fullWidth
          type="button"
          trailingIconSrc={ICONS.logout}
          trailingIconAlt=""
          className="session-detail-mini__exit"
        >
          Exit Session
        </CustomButton>
      </div>
    </div>
  </div>
  )
}

export default SessionDetailMini
